import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./hooks/AuthContext";

import GlobalStyles from "./styles/GlobalStyles";
import { PrinterProvider } from "./hooks/PrintersContext";
import { OnboardProvider } from "./hooks/OnboardContext";
import { TipsProvider } from "./hooks/TipsContext";
import Router from "./routes";
import { WebSocketProvider } from "./hooks/PrinterWebSocketContext";
import { FinancialStatusProvider } from "./hooks/FinancialStatusContext";
import CustomToast from "./components/CustomToast";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <WebSocketProvider>
          <TipsProvider>
            <PrinterProvider>
              <OnboardProvider>
                <FinancialStatusProvider>
                  <Router />
                </FinancialStatusProvider>
              </OnboardProvider>
            </PrinterProvider>
          </TipsProvider>
        </WebSocketProvider>
      </AuthProvider>
      <GlobalStyles />
      <CustomToast />
    </BrowserRouter>
  );
}

export default App;
